var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitsEligibilityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24999 7.66683H3.58332V5.66683H5.24999V4.00016H7.24999V5.66683H8.91666V7.66683H7.24999V9.3335H5.24999V7.66683ZM6.24999 0.333496L0.916656 2.3335V6.3935C0.916656 9.76016 3.18999 12.9002 6.24999 13.6668C9.30999 12.9002 11.5833 9.76016 11.5833 6.3935V2.3335L6.24999 0.333496ZM10.25 6.3935C10.25 9.06016 8.54999 11.5268 6.24999 12.2802C3.94999 11.5268 2.24999 9.06683 2.24999 6.3935V3.26016L6.24999 1.76016L10.25 3.26016V6.3935Z",
    fill: "#009A44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitsEligibilityIcon);
export default __webpack_public_path__ + "static/media/BenefitsEligibilityIcon.4e4808d4ce5da415a619e823fcfd88c5.svg";
export { ForwardRef as ReactComponent };